import {AbstractControl, FormControl, Validators} from '@angular/forms';

const PASSWORD_REGEX = '^(?=.*[A-Z])(?=.*[0-9]).{8,}$';
const USERNAME_REGEX = '^[A-Za-z0-9-_-]+$';

export function NoWhitespaceValidator(control: AbstractControl): any {
    const value = control.value ? (control.value).toString() : null;
    const isWhitespace = (value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : {whitespace: true};
}

export function NameOrEmailRequired(nameControl: FormControl, emailControl: FormControl): any {
    return () => {
        removeErrors(['missingBoth'], nameControl);
        removeErrors(['missingBoth'], emailControl);
        if (!nameControl.value && !emailControl.value) {
            nameControl.setErrors({missingBoth: true});
            emailControl.setErrors({missingBoth: true});
        }
    };
}

export function passwordValidator(): Validators {
    return Validators.pattern(PASSWORD_REGEX);
}

export function CompareControls(control1: FormControl, control2: FormControl): any {
    return () => {
        if (control1.value !== control2.value) {
            control2.setErrors({mustMatch: true});
        } else {
            control2.setErrors(null);
        }
    };
}

export function getPasswordRegex(): string {
    return PASSWORD_REGEX;
}

export function getUsernameRegex(): string {
    return USERNAME_REGEX;
}

export function removeErrors(keys: string[], control: AbstractControl): any {
    if (!control || !keys || keys.length === 0) {
        return;
    }

    const remainingErrors = keys.reduce((errors, key) => {
        delete errors[key];
        return errors;
    }, {...control.errors});

    control.setErrors(remainingErrors);

    if (Object.keys(control.errors || {}).length === 0) {
        control.setErrors(null);
    }
}


